import { HStack, VStack } from '@chakra-ui/react';
import { Box, Flex, Image } from '@cmpsr/components';

const industryProofs = {
  width: { base: '150px', md: '212px' },
  height: { base: '63px', md: '70px' },
  p: '15px 15px',
  alignItems: 'center',
  justifyContent: 'center',
};

const imageUrls = [
  '/images/industry-proofs/white/harvard.svg',
  '/images/industry-proofs/white/american-cancer-society.svg',
  '/images/industry-proofs/white/stanford.svg',
  '/images/industry-proofs/white/american-college-of-radiology.svg',
  '/images/industry-proofs/white/johns-university.svg',
];

const IndustryProofImage = ({ src }: { src: string }) => (
  <Flex {...industryProofs}>
    <Image src={src} />
  </Flex>
);

export const IndustryProofsLight = () => {
  return (
    <Box width={{ base: '100%', lg: '100%' }} my="-7px">
      <HStack spacing="14px" justifyContent="center" display={{ base: 'none', lg: 'flex' }}>
        {imageUrls.map((src) => (
          <IndustryProofImage key={src} src={src} />
        ))}
      </HStack>

      <VStack spacing="14px" display={{ base: 'flex', lg: 'none' }}>
        <HStack spacing="14px" justifyContent="center">
          <IndustryProofImage src={imageUrls[0]} />
          <IndustryProofImage src={imageUrls[1]} />
        </HStack>
        <HStack spacing="14px" justifyContent="center">
          <IndustryProofImage src={imageUrls[2]} />
          <IndustryProofImage src={imageUrls[4]} />
        </HStack>
      </VStack>
    </Box>
  );
};
